<template>
  <div id="app">
    <router-view></router-view>
</div>
</template>

<script>

export default {
  name: 'App'
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  height: 100%;
}

html body{
  width:100%;
	height:100%;
  position: fixed; 
  left: 0px;
  top: 0px;
  margin:0;
  padding: 0;
}
.el-table th.gutter {
  display: table-cell!important;
}
</style>
